import React, { useLayoutEffect, useRef, useState } from "react";
import { Popover, Whisper } from "rsuite";
import { OverlayTriggerProps } from "rsuite/esm/internals/Overlay/OverlayTrigger";

import "./Overflow.less";

interface Props extends Omit<OverlayTriggerProps, "speaker" | "children"> {
    children: string;
}

const Overflow: React.FC<Props> = ({
    trigger = "hover",
    placement = "auto",
    children,
    ...props
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [overflowed, setOverflowed] = useState<boolean>(false);

    useLayoutEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const overflowed =
            element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth;
        const update = () => setOverflowed(overflowed);
        update();

        const observer = new ResizeObserver(update);
        observer.observe(element);

        return () => observer.disconnect();
    }, [children]);

    const container = (
        <div ref={ref} className={"overflow__container"}>
            {children}
        </div>
    );

    return overflowed ? (
        <Whisper
            trigger={trigger}
            placement={placement}
            speaker={
                <Popover className={"overflow__popover"} arrow={false}>
                    {children}
                </Popover>
            }
            {...props}
        >
            {container}
        </Whisper>
    ) : (
        container
    );
};

export default Overflow;
